<div class="container-scroller">
    <div class="container-fluid page-body-wrapper full-page-wrapper pt-0">
        <div class="content-wrapper d-flex align-items-center auth">
            <div class="row flex-grow">
                <div class="col-lg-4 mx-auto">
                    <div class="auth-form-light text-left">
                        <div class="lock-div">
                            <i _ngcontent-vak-c58="" class="fa fa-lock"></i>
                            <h4>Enter your email or username and we'll send you a otp to get back into your account.
                            </h4>
                            <form [formGroup]="formmaster" class="forms-sample enviornmentFilter pt-3">
                                <div *ngIf="opd == 0 " style="text-align:left !important;">
                                    <input type="email" formControlName="UserName" style="background: #f2f2f2;"
                                        [class.is-invalid]=" this.formmaster.get('UserName').touched && this.formmaster.get('UserName').invalid"
                                        class="form-control form-control-lg" id="UserName"
                                        placeholder="Enter Your Username" autocomplete="off">
                                    <span class="mandatory-span" *ngIf="this.formmaster.get('UserName').touched
                                        && this.formmaster.get('UserName').value == ''">Username is required</span>
                                    <span class="mandatory-span" *ngIf="this.formmaster.get('UserName').touched
                                        && this.formmaster.get('UserName').value != '' &&
                                        this.formmaster.get('UserName').invalid">Invalid format</span>
                                    <div class="mt-3 opt-send">
                                        <button (click)="validateUser()"
                                            [disabled]="this.formmaster.get('UserName').invalid"
                                            class="btn btn-block btn-primary btn-lg font-weight-medium auth-form-btn save-button blue-button">Send
                                            OTP
                                        </button>
                                    </div>
                                </div>
                                <div *ngIf="opd == 1" style="text-align:left !important;">
                                    <div class="form-group-mt-3">
                                        <label>OTP</label>
                                        <input type="email" formControlName="OTP" minlength="4" maxlength="4"
                                            onkeypress="return isNumberKey(event)"
                                            [class.is-invalid]=" this.formmaster.get('OTP').touched && this.formmaster.get('OTP').invalid"
                                            class="form-control form-control-lg" id="OTP" placeholder="Enter OTP"
                                            autocomplete="off">
                                        <span class="mandatory-span"
                                            *ngIf="this.formmaster.get('OTP').touched && this.formmaster.get('OTP').value == ''">OTP
                                            is
                                            required</span>
                                        <span class="mandatory-span"
                                            *ngIf="this.formmaster.get('OTP').touched && this.formmaster.get('OTP').value != '' && this.formmaster.get('OTP').invalid">Invalid
                                            Format</span>
                                    </div>
                                    <div *ngIf="showOTP" style="display:inline-flex;width:100%;">
                                        <a *ngIf="!remainingTime" (click)="resendOtp()"
                                            style="width:100%;text-align: left;">Resend OTP</a>
                                        <p *ngIf="remainingTime" style="width:100%;text-align: right;">Resend OTP in 0{{
                                            minutes }} : {{ seconds
                                            }}</p>
                                    </div>

                                    <div class="mt-3">
                                        <button [disabled]="this.formmaster.get('OTP').invalid" (click)="validateOtp()"
                                            class="btn btn-block btn-primary btn-lg font-weight-medium auth-form-btn save-button blue-button">Verify
                                            OTP </button>
                                    </div>
                                </div>
                                <div *ngIf="opd == 2" style="text-align:left !important;">
                                    <div class="form-group">
                                        <label>New Password</label>
                                        <input [type]="show1?'text':'password'" formControlName="password" minlength="8"
                                            maxlength="20"
                                            [class.is-invalid]=" this.formmaster.get('password').touched && this.formmaster.get('password').invalid"
                                            class="form-control form-control-lg" id="password"
                                            placeholder="Enter New Password" autocomplete="off">
                                        <button (click)="onClick(1)" class="login-eye-button">
                                            <i class="fa fa-eye " aria-hidden="true" *ngIf="!show1"></i>
                                            <i class="fa fa-eye-slash " aria-hidden="true" *ngIf="show1"></i>
                                        </button>
                                        <span class="mandatory-span"
                                            *ngIf="this.formmaster.get('password').touched && this.formmaster.get('password').value == ''">Enter New
                                            Password</span>
                                        <span class="mandatory-span"
                                            *ngIf="this.formmaster.get('password').touched && this.formmaster.get('password').value != '' && this.formmaster.get('password').invalid">Invalid
                                            Format</span>

                                    </div>

                                    <div class="form-group">
                                        <label>Confirm Password</label>
                                        <input [type]="show2?'text':'password'" formControlName="confirmpassword"
                                            minlength="8" maxlength="20"
                                            [class.is-invalid]=" this.formmaster.get('confirmpassword').touched && this.formmaster.get('confirmpassword').invalid"
                                            class="form-control form-control-lg" id="confirmpassword" autocomplete="off"
                                            placeholder="Re-enter Password">
                                        <button (click)="onClick(2)" class="login-eye-button">
                                            <i class="fa fa-eye" aria-hidden="true" *ngIf="!show2"></i>
                                            <i class="fa fa-eye-slash" aria-hidden="true" *ngIf="show2"></i>
                                        </button>
                                        <span class="mandatory-span"
                                            *ngIf="this.formmaster.get('confirmpassword').touched && this.formmaster.get('confirmpassword').value == ''">Re-enter
                                            Password</span>
                                        <span class="mandatory-span"
                                            *ngIf="this.formmaster.get('confirmpassword').touched && this.formmaster.get('confirmpassword').value != '' && this.formmaster.get('confirmpassword').invalid">Invalid
                                            Format</span>
                                    </div>
                                    <div>
                                        <label class="mandatory-span" *ngIf=" (this.formmaster.get('confirmpassword').touched && this.formmaster.get('password').touched) && (this.formmaster.get('password').value != '' && this.formmaster.get('confirmpassword').value != '') && (this.formmaster.get('password').invalid || this.formmaster.get('confirmpassword').invalid|| this.formmaster.get('confirmpassword').value != this.formmaster.get('password').value)">Password doesn't match.</label>
                                    </div>
                                    <div class="form-group">
                                        <label><b>Note:</b> Password should be atleast 08 characters long.</label>
                                    </div>
                                    <div (click)="resetPassword()" class="mt-3">
                                        <button
                                            [disabled]="this.formmaster.get('password').invalid || this.formmaster.get('confirmpassword').value != this.formmaster.get('password').value"
                                            class="btn btn-block btn-primary btn-lg font-weight-medium auth-form-btn save-button blue-button">Change
                                            Password
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                        <div class="forgot-footer">
                            <a [routerLink]="['/auth/login']" class="auth/resetpassword text-black forgot-button">Back To
                                Login</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- content-wrapper ends -->
    </div>
    <!-- page-body-wrapper ends -->
</div>